export { Navigator } from './entities/navigator';
export {
  resolveLinkToDoc,
  resolveRouteLinkMeta,
  toDocSearchParams,
  toURLSearchParams,
} from './utils';
export { NavigationButtons } from './view/navigation-buttons';

import { type Framework } from '@toeverything/infra';

import { WorkbenchService } from '../workbench/services/workbench';
import { WorkspaceScope } from '../workspace';
import { Navigator } from './entities/navigator';
import { NavigatorService } from './services/navigator';
import { ExpandStateManager } from './services/expand-state-manager';
import { GlobalCache } from '../storage';

export function configureNavigationModule(framework: Framework) {
  framework
    .service(ExpandStateManager, [GlobalCache])
    .scope(WorkspaceScope)
    .service(NavigatorService)
    .entity(Navigator, [WorkbenchService]);
}
